<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="true"
  [style]="{width: '64rem', maxWidth: '92vw'}"
  [closable]="true"
  styleClass="hr-provider-modal"
  data-testid="hr-tool-provider-modal"
>
  @if (group(); as group) {
    <div class="flex flex-col gap-6 md:flex-row">
      <!-- Brand panel -->
      <div
        class="flex flex-col gap-3 border-b border-themed pb-5 md:w-2/5 md:border-b-0 md:border-r md:pb-0 md:pr-6"
      >
        <div class="card flex h-24 items-center justify-center bg-second-level p-4">
          @if (showLogo()) {
            <img
              [src]="group.logoUrl"
              [alt]="group.name"
              class="max-h-full max-w-full object-contain"
              (error)="onLogoError()"
            />
          } @else {
            <span class="text-lg font-semibold">{{ group.name }}</span>
          }
        </div>

        <h2 class="text-2xl font-bold tracking-tight">{{ group.name }}</h2>

        @if (group.tagline; as tagline) {
          <p class="text-button-red text-xs font-semibold uppercase tracking-widest">
            {{ tagline }}
          </p>
        }
        @if (group.description; as description) {
          <p class="text-sm text-muted-color">{{ description }}</p>
        }

        <div class="mt-2 flex flex-col gap-1.5 text-xs text-muted-color">
          @if (group.headquarters; as headquarters) {
            <span class="flex items-center gap-2">
              <i class="pi pi-map-marker"></i>{{ headquarters }}
            </span>
          }
          @if (group.meta?.foundedYear; as foundedYear) {
            <span class="flex items-center gap-2">
              <i class="pi pi-calendar"></i>
              {{ 'hrTool.providerModal.founded' | transloco }} {{ foundedYear }}
            </span>
          }
          @if (group.meta?.website; as website) {
            <a
              [href]="website"
              target="_blank"
              rel="noopener noreferrer"
              class="text-button-red flex items-center gap-2 hover:underline"
            >
              <i class="pi pi-globe"></i>{{ 'hrTool.providerModal.visitWebsite' | transloco }}
            </a>
          }
        </div>
      </div>

      <!-- Product list -->
      <div class="flex flex-col gap-3 md:w-3/5">
        <p class="text-xs font-semibold uppercase tracking-widest text-muted-color">
          {{ group.tools.length }} {{ 'hrTool.providerModal.products' | transloco }}
        </p>
        @if (group.tools.length === 0) {
          <p class="py-8 text-center text-sm text-muted-color">
            {{ 'hrTool.providerModal.noProducts' | transloco }}
          </p>
        }
        <div class="flex flex-col gap-2">
          @for (tool of group.tools; track tool.id) {
            <div class="hr-product-row card flex items-center gap-2 bg-second-level p-4">
              <button
                type="button"
                class="flex min-w-0 flex-1 items-start gap-3 text-left"
                (click)="openTool(tool)"
                [attr.data-testid]="'hr-tool-provider-modal-product-' + tool.id"
              >
                <span class="min-w-0 flex-1">
                  <span class="hr-product-row__title block truncate font-semibold">
                    {{ tool.translatedName }}
                  </span>
                  <span class="mt-1 line-clamp-2 block text-xs text-muted-color">
                    <app-safe-html-output [html]="tool.translatedDescription" />
                  </span>
                </span>
                <i class="hr-product-row__arrow pi pi-arrow-right text-muted-color"></i>
              </button>
              <button
                type="button"
                class="hr-compare-btn"
                (click)="addToCompare(tool)"
                [title]="'hrTool.detail.compare' | transloco"
                [attr.aria-label]="'hrTool.detail.compare' | transloco"
                [attr.data-testid]="'hr-tool-provider-modal-compare-' + tool.id"
              >
                <i class="pi pi-plus"></i>
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  }
</p-dialog>
